// extracted by mini-css-extract-plugin
module.exports = {"wk0r5lw":"wk0r5lw"};